import React, { useState, useEffect } from "react";
import {
  getDriverChargingSites,
  getAllChargingSites,
  addDriverChargingSite,
  updateEvChargingSiteId,
} from "../../actions/commonActions";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import Loading from "../Shared/Loading";
import { useLocation } from "react-router-dom";
import { setChargingStationID } from "../../utils/setAxiosHeader";
import NewSiteModal from "./NewSiteModal";

const ChargingSitesHeader = () => {
  let { pathname } = useLocation();

  const dispatch = useDispatch();

  const { driverChargingSites, appOnlineOfflineModeDisplay } = useSelector(
    (redux) => redux.common
  );

  const [chargingSites, setChargingSites] = useState([]);

  console.log("CHARGING SITES ID INITIAL", chargingSites)
  // ev_charging_site_id
  const [currentChargingSite, setCurrentChargingSite] = useState(
    localStorage.getItem("ev_charging_site_id")
  );



  console.log("Current Charging Site: ", currentChargingSite)
  const [addNewSite, setAddNewSite] = useState(false);

  useEffect(() => {
    getDriverChargingSites(dispatch);
  }, []);

  useEffect(() => {
    getDriverChargingSites(dispatch);
  }, [localStorage.getItem("driver_id")]);

  useEffect(() => {
    if (
      ["/my_schedule"].includes(pathname) &&
      currentChargingSite === -1 &&
      chargingSites.length > 0
    ) {
      setCurrentChargingSite(chargingSites[0].ev_charging_site_id);
      localStorage.setItem(
        "ev_charging_site_id",
        chargingSites[0].ev_charging_site_id
      );
    }
  });

  useEffect(() => {
    setCurrentChargingSite(localStorage.getItem("ev_charging_site_id"));
  }, [localStorage.getItem("ev_charging_site_id")]);

  useEffect(() => {
    let filteredChargingSites = driverChargingSites.filter(
      (s) => !s.template_flag
    );
    setChargingSites(filteredChargingSites);
  }, [driverChargingSites]);

  // useEffect(() => {
  //   let value = chargingSites[0]?.ev_charging_site_id;
  //   setCurrentChargingSite(value);
  //   updateEvChargingSiteId(dispatch, value);
  //   localStorage.setItem("ev_charging_site_id", value);
  //   setChargingStationID(value);

  // }, [chargingSites])

  const changeCurrentChargingSite = (e) => {
    const { value } = e.target;
    setCurrentChargingSite(value);
    updateEvChargingSiteId(dispatch, value);
    localStorage.setItem("ev_charging_site_id", value);
    setChargingStationID(value);
    window.location.reload();
  };

  // Don't show for follwing url;s
  if (["/", "/register-profile", "/forgot_password"].includes(pathname)) {
    return null;
  }

  return (
    <div className="text-center">
      <nav
        className={`navbar navbar-expand-sm ${appOnlineOfflineModeDisplay
          ? "bg-light nav-charging-site"
          : "nav-charging-site-offline"
          } `}
      >
        <div className="float-right mr-2 active-charging-site ml-2 mt-0">
          <select
            className="custom-select"
            value={currentChargingSite}
            onChange={changeCurrentChargingSite}
          >
            {!["/my_schedule"].includes(pathname) && (
              <option key={-1} value={-1}>
                All Stations
              </option>
            )}
            {chargingSites.map((site, i) => (
              <option key={i} value={site.ev_charging_site_id}>
                {site.name}
              </option>
            ))}
          </select>
        </div>
        {/* <div>
          <button
            className="btn btn-sm mr-2 border-dark"
            onClick={() => {
              setAddNewSite(true);
            }}
          >
            <i className="fa fa-plus-circle mr-1" aria-hidden="true"></i>
            Add Station
          </button>
        </div> */}
        {!appOnlineOfflineModeDisplay && (
          <p className="mb-0 mr-auto ml-auto">
            <strong>You're Offline! Please connect to the internet.</strong>
          </p>
        )}
      </nav>
      {/* {addNewSite && <NewSiteModal setAddNewSite={setAddNewSite} />} */}
    </div>
  );
};

// const NewSiteModal = ({ setAddNewSite }) => {
//   const dispatch = useDispatch();

//   const { allChargingSites, driverChargingSites } = useSelector(
//     (redux) => redux.common
//   );

//   const [chargingSites, setChargingSites] = useState([]);

//   const [selectedChargingSite, setSelectedChargingSite] = useState("");

//   const [driverChargingSiteIds, setDriverChargingSiteIds] = useState([]);

//   useEffect(() => {
//     getAllChargingSites(dispatch);
//   }, []);

//   useEffect(() => {
//     const filteredChargingSites = allChargingSites.filter(
//       (site) => !driverChargingSiteIds.includes(site.ev_charging_site_id)
//     );
//     setChargingSites(filteredChargingSites);
//   }, [allChargingSites]);

//   useEffect(() => {
//     setDriverChargingSiteIds(
//       driverChargingSites.map((site) => site.ev_charging_site_id)
//     );
//   }, [driverChargingSites]);

//   const onSubmit = () => {
//     addDriverChargingSite(
//       dispatch,
//       {
//         ev_charging_site_id: selectedChargingSite,
//       },
//       () => {
//         setAddNewSite(false);
//       }
//     );
//   };

//   const onModalClose = () => {
//     setAddNewSite(false);
//   };

//   return (
//     <div>
//       <Modal show={true} centered onHide={onModalClose}>
//         <Modal.Header>
//           <h5 className="modal-title">Add New Charging Site</h5>
//           <button
//             type="button"
//             className="close"
//             data-dismiss="modal"
//             onClick={onModalClose}
//           >
//             &times;
//           </button>
//         </Modal.Header>
//         <Modal.Body>
//           {(chargingSites.length > 0 && (
//             <select
//               className="custom-select"
//               onChange={(e) => {
//                 setSelectedChargingSite(e.target.value);
//               }}
//             >
//               <option value=""> Select Charging Station</option>
//               {chargingSites.map((site) => (
//                 <option value={site.ev_charging_site_id}>{site.name}</option>
//               ))}
//             </select>
//           )) || (
//             <div className="row justify-content-center align-items-center">
//               <Loading />
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <button
//             className="btn btn-info btn-sm "
//             onClick={() => {
//               onSubmit();
//             }}
//           >
//             Save
//           </button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

export default ChargingSitesHeader;
